import { useContext } from 'react';

import useRecentlyViewedProduct from '~/hooks/useRecentlyViewedProduct';

import TourDetailsContext from './TourDetailsContext';

interface Props {
  tourId: string;
}

export default function TourRecentlyViewedProductTracker({ tourId }: Props) {
  const { tourDetails } = useContext(TourDetailsContext);

  useRecentlyViewedProduct({
    id: tourId ? `tours:${tourId}` : undefined,
    label: tourDetails?.title,
    productLabel: 'Tours',
  });

  return null;
}
